export default {
  title: "Shop by category",
  all_categories: "All categories"
}
